import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { change, Field } from 'redux-form';
import Button from '../../elements/Button';
import Text from '../../fields/Text';
import IconWarning from '../../icons/IconWarning';
import styles from './styles.scoped.css';

export default function FilterUserForm({
  handleSubmit,
  handledReset,
  message,
  code,
  handledClose = () => {}
}) {
  const dispatch = useDispatch();
  const { values } = useSelector((state) => state.form.filterUserForm);

  const onSubmit = async (e) => {
    e.preventDefault();
    dispatch(change('filterUserForm', 'search', ''));
    handleSubmit(values);
  };

  useEffect(() => {
    if (values.search) {
      handledReset();
    }
  }, [values.search]);

  return (
    <form className={styles.formContainer} onSubmit={onSubmit}>
      <Field
        component={Text}
        inputProps={{
          placeholder: 'Masukkan email user...'
        }}
        meta={{
          error: (message && code !== 401) && <>
            <IconWarning className={styles.icon} color="#CF212A" /> {message}
          </>,
          touched: true,
        }}
        name={'search'}
      />
      <div className={styles.containerBtn}>
        <Button
          className={styles.btn}
          disabled={!values.search}
          style={'blue'}
          type={'submit'}
        >Cari User</Button>
      </div>
    </form>
  );
}

FilterUserForm.propTypes = {
  code: PropTypes.number,
  handledClose: PropTypes.func,
  handledReset: PropTypes.func,
  handleSubmit: PropTypes.func,
  message: PropTypes.string
};
